import { Component, Input } from '@angular/core';
import { ListItem } from '../../core/models/list-item';

@Component({
  selector: 'irar-site-list',
  template: `
  <div id="sites">
    <table width="95%" border="0" cellpadding="5" cellspacing="0">
      <tr>
        <th align="left">TECHNICAL NAME</th>
        <th align="left">COMMON NAME</th>
        <th>&nbsp;</th>
      </tr>
      <tr *ngFor="let s of sites">
        <td valign="top">{{s.abbreviation}}</td>
        <td valign="top">{{s.title}}</td>
        <td><a [routerLink]="['/admin', 'site', s.id]">EDIT</a></td>
      </tr>
    </table>
  </div>
  `
})
export class SiteListComponent {
  @Input() sites: ListItem[];
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/components/site-list.ts